const styles = {
  container: {
    borderRadius: 5,
    borderTopLeftRadius: 0,
    backgroundColor: 'white',
    padding: 10,
    width: '100%',
  },
};

export default styles;
